import moment from 'moment'
import * as actionTypes from './actionTypes'
import { formSeatMap } from '../../utils';
const initialState = {
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.INVENTORY_CALENDAR_VIEW: {
      return { ...state, inventoryCalendarViewData: payload.data || [] }
    }
    case actionTypes.INVENTORY_ROUTE_LEVEL_VIEW: {
      return { ...state, inventoryRouteLevelData: payload.data || [] }
    }
    case actionTypes.INVENTORY_ALL_ROUTES_REFRESH_DATA: {
      return { ...state, inventoryAllRoutesRefreshData: payload.data || [] }
    }
    case actionTypes.INVENTORY_ROUTE_LEVEL_REFRESH_DATA: {
      return { ...state, inventoryRouteLevelRefreshData: payload.data || [] }
    }
    case actionTypes.REJECTION_REASONS_DATA: {
      return { ...state, rejectionReasons: payload.data || [] }
    }
    default:
      return state
  }
}
